import { createTrackingUtils } from "../index.js";
import { isEqual } from "lodash";
import { useCallback } from "react";
import { LOCATION_IATA_CODE_AND_TYPE_SEPARATOR, PARAM_LIST_SEPARATOR, MULTISTOP_IATA_LIST_SEPARATOR } from "@flights/constants";
const utils = createTrackingUtils({
    name: "flights_web_cat_returning_user_prefill_search",
    stages: {},
    defaultStage: 1,
    goals: {
        origin_changed: 1,
        destination_changed: 2,
        dates_changed: 3,
        anything_changed: 4
    },
    goalsWithValue: ["flights_cat_index_time_from_load_to_search_in_sec"]
});
export const useTrackReturningUserPrefillGoals = () => {
    return useCallback((prefilledSearchState, currentSearchState) => {
        const originChanged = getFromCodes(prefilledSearchState) !== getFromCodes(currentSearchState);
        if (originChanged) {
            utils.goals.origin_changed();
        }
        const destinationChanged = getToCodes(prefilledSearchState) !== getToCodes(currentSearchState);
        if (destinationChanged) {
            utils.goals.destination_changed();
        }
        const datesChanged = getDates(prefilledSearchState) !== getDates(currentSearchState);
        if (datesChanged) {
            utils.goals.dates_changed();
        }
        const otherFieldsChanged = ["adults", "children", "cabinClass", "type", "isDirect"].filter((field) => !isEqual(prefilledSearchState[field], currentSearchState[field]));
        const anyFieldChanged = originChanged || destinationChanged || datesChanged || otherFieldsChanged.length > 0;
        if (anyFieldChanged) {
            utils.goals.anything_changed();
        }
    }, []);
};
const getLocationCodes = (locations) => locations
    .map(({ code, type }) => [code, type].filter(Boolean).join(LOCATION_IATA_CODE_AND_TYPE_SEPARATOR))
    .join(PARAM_LIST_SEPARATOR);
const getFromCodes = (state) => state.searchSegments.map((segment) => getLocationCodes(segment.from)).join(MULTISTOP_IATA_LIST_SEPARATOR);
const getToCodes = (state) => state.searchSegments.map((segment) => getLocationCodes(segment.to)).join(MULTISTOP_IATA_LIST_SEPARATOR);
const getDates = (state) => state.searchSegments
    .map((segment) => `${segment.departureDate || ""}-${segment.returnDate || ""}`)
    .join(MULTISTOP_IATA_LIST_SEPARATOR);
export default { ...utils, useTrackReturningUserPrefillGoals };
